import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/InvoiceMovementReport/InvoiceMovementReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ARInvoiceMovementReportActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/InvoiceMovementReport/InvoiceMovementReport")
        this.compName = "ARInvoiceMovementReport"
	}

	render() {
		return (
			<Activity 
				name={this.compName}
				RenderedComponent={this.RenderedComponent}
				context={this.compName}
				action={this.compName}
				formActions={FormAction}
            />
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ARInvoiceMovementReportActivity)
